import { render } from "./NotificationHost.vue?vue&type=template&id=5f977512"
import script from "./NotificationHost.vue?vue&type=script&lang=js"
export * from "./NotificationHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__